import { render, staticRenderFns } from "./ScreeningPlanList.vue?vue&type=template&id=4f64eb56&scoped=true&"
import script from "./ScreeningPlanList.vue?vue&type=script&lang=js&"
export * from "./ScreeningPlanList.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningPlanList.vue?vue&type=style&index=0&id=4f64eb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f64eb56",
  null
  
)

export default component.exports